import React from 'react';
import PropTypes from 'prop-types';

import BWModal from '../BWModal';
import BWModalAlert from '../BWModalAlert';
import { BW_MODAL_TONES } from '../constants';

const BWConfirmModal = ({
  open,
  title,
  description,
  tone = 'warning',
  children,
  confirmLabel = 'Xác nhận',
  cancelLabel,
  confirmLoading,
  confirmDisabled,
  onConfirm,
  onClose,
  ...modalProps
}) => (
  <BWModal
    {...modalProps}
    open={open}
    title={title}
    size='sm'
    onClose={onClose}
    maskClosable={!confirmLoading}
    keyboard={!confirmLoading}
    closeDisabled={confirmLoading}
    cancelAction={
      cancelLabel === false
        ? null
        : {
            label: cancelLabel || 'Quay lại',
          }
    }
    primaryAction={
      tone === 'danger'
        ? null
        : {
            label: confirmLabel,
            onClick: onConfirm,
            loading: confirmLoading,
            disabled: confirmDisabled,
          }
    }
    dangerAction={
      tone === 'danger'
        ? {
            label: confirmLabel,
            onClick: onConfirm,
            loading: confirmLoading,
            disabled: confirmDisabled,
          }
        : null
    }>
    <BWModalAlert tone={tone} title={description}>
      {children}
    </BWModalAlert>
  </BWModal>
);

BWConfirmModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  tone: PropTypes.oneOf(BW_MODAL_TONES),
  children: PropTypes.node,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  confirmLoading: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BWConfirmModal;
